// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
const letterSpacings = {
    100: "-0.05em",
    200: "-0.04em",
    300: "-0.03em",
    400: "-0.02em",
    500: "-0.01em",
    600: "0em",
    700: "0.01em",
    800: "0.02em",
    900: "0.03em",
    1000: "0.04em",
    1100: "0.05em",
};
module.exports = letterSpacings;
//# sourceMappingURL=letterSpacings.js.map